import React from 'react';
import Svg from './../Svg';
import guid from "../../helpers/guid";

export default class Circle extends Svg {
    constructor() {
        super();
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }

    static create() {
        return new Circle();
    }

    size(x, y, r) {
        this.cx = x;
        this.cy = y;
        this.r = r;
        return this;
    }

    draw() {
        this.shape = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        this.shape.setAttribute('cx', this.cx);
        this.shape.setAttribute('cy', this.cy);
        this.shape.setAttribute('r', this.r);
        this.style(this.shape);
        return this.shape;
    }

    element() {
        return <circle
            cx={this.cx}
            cy={this.cy}
            r={this.r}
            key={`key-${guid()}`}
            fill={this.fill}
            stroke={this.stroke}
            strokeWidth={this.strokeWidth}
        />
    }
}
